export default class ColorHelper
{
  static toHex2(x) {
    return ("0" + parseInt(x).toString(16)).slice(-2);
  };
    
  static rgbArrayToHex(cm){
    return this.toHex2(cm[0]) + this.toHex2(cm[1]) + this.toHex2(cm[2]);
  };
    
  static hexaToName(hex, sub_color_set ) {
    //var sub_color_set = color_set[ $('select[id=palette-drop-down]').val() ] ;
    var color = Cx_.find(sub_color_set, function (obj) {
      return obj.hex === hex;
    });
    return (typeof color != 'undefined') ? color.name : hex;
  };

  static hex2rgb (color) {
    return [parseInt(color.substr(1, 2), 16),
        parseInt(color.substr(3, 2), 16),
        parseInt(color.substr(5, 2), 16)];
  };

  static hexaToNameFindAny(hex ) {
    var color ;
    for ( var key in window.AppInstance.instance().color_set ) 
    {
      if ( color === undefined )
      {
        color = Cx_.find(window.AppInstance.instance().color_set[key], function (obj) {
          return obj.hex === hex;
        });
      }
    }
    return ( color !== undefined ) ? color.name : hex;
    return hex ;
  };
    
  static argbToRGB(color) {
    return color.substring(2, 8);
  };
    
    //produces an array of { ColorZoneName, ColorZoneIndexes[] }
  static consolidate_color_zones() {
    var map = [];
    var color_zones = Cx.uniqueColorZones(window.AppInstance.instance().doc_figures);
    Cx_.forEach( color_zones, function(zone) {
      var id_tint_map = ColorHelper.get_zones_index_spot(zone.value.spotColorName, color_zones) ;
      map.push({ SpotColorName: zone.value.spotColorName
              ,  ZoneMap: id_tint_map[0] 
              ,  TintMap: id_tint_map[1] });
    });
    window.AppInstance.instance().zone_color_map = ColorHelper.consolidate_map(map);
  };

  static consolidate_map(map) {
    var aux = [];
    Cx_.forEach(map, function(m){
        var add = true ;
        Cx_.forEach(aux, function(a){
          if (ColorHelper.equal_map(a.ZoneMap, m.ZoneMap))
              add =false;
        });
        if (add)
          aux.push(m);
    });
    return aux ;
  };

  static equal_map(list,list2)
  {
    var result = false;
    var correct = 0;
    if(list.length == list2.length)
    {
      for(var i = 0; i< list.length; i++)
      {
        for(var j = 0; j < list2.length; j++)
        {
          if(list[i] == list2[j])
          {
            correct++;
            if(correct == list.length && correct == list2.length)
            {
              result = true;
            }
          }
        }
      }
    }
    return result;
  };

  static change_color( swatches, figures, force_color_change ) {

    if ( figures === undefined )
        figures = window.AppInstance.instance().doc_figures; 
        
    var color_zones = Cx.uniqueColorZones(figures);
    var is_consolidated = swatches.length !== color_zones.length ;

    Cx_.forEach(swatches, function(swatch, i) {
      var origSpotColorName = $(swatch).find("input[name=origName]").val() ;
      var current = $(swatch).find("input[name=selectedName]").val() ;
      var prev    = $(swatch).find("input[name=prevName]").val() ;
      //color effectively changed
      if ( ( current !== prev ) || force_color_change )
      {
        var map = Cx_.filter( window.AppInstance.instance().zone_color_map, function(m) { return m.SpotColorName === origSpotColorName }) ;
        if ( map.length > 0 )
        {
          Cx_.forEach(map[0].ZoneMap, function(i){
            var z_rgb = Cx.Color.fromRgb( $(swatch).find("input[name=selectedHex]").val() );
            var target_zone = color_zones[i] ;
            if (target_zone.value.tint < 1 )
                z_rgb = Cx.Color.fromRgb( ColorHelper.rgbArrayToHex( Cx.interpolate_rgb( Cx.Color.White().rgbArray, z_rgb.rgbArray, target_zone.value.tint ) ) ) ;
            z_rgb.spotColorName = current;
            z_rgb.tint = target_zone.value.tint;
            z_rgb.alpha = target_zone.value.alpha;
            Cx.changeColorZone(figures, target_zone, z_rgb);
          });
        }
      }
    });
  };

  static get_zones_index_spot(spotColorName, zones)
  {
    var idxs = [];
    var tints = [];
    Cx_.forEach(zones, function(z,i){ 
        if ( z.value.spotColorName == spotColorName )
        {
            idxs.push(i);
            tints.push(z.value.tint);
        }
    });
    return [idxs, tints] ;
  };

  static get_color_tuples(doc_figure) {
    var all_tuples = [];
    var color_sets = JSON.parse(decodeURI(doc_figure.metadata.get('colorSet')));
    var color_zones = Cx.uniqueColorZones(window.AppInstance.instance().doc_figures);

    Cx_.forEach(color_sets, function(set) {
        var set_color = Cx.isArray(set.Color) ? set.Color : [set.Color] ;
        var processed_spot = [];
        var color_set_tuple = [];
        Cx_.forEach(set_color, function(spot) {
            if ( spot.ColorName.length == 0 )
                spot.ColorName = ColorHelper.hexaToNameFindAny(spot.RGB);
            if ( processed_spot.indexOf(spot.ColorName) == -1 )
            {
                processed_spot.push(spot.ColorName);
                for (var j = 0; j < window.AppInstance.instance().zone_color_map[processed_spot.length-1].ZoneMap.length; j++)
                {
                    var tint = window.AppInstance.instance().zone_color_map[processed_spot.length-1].TintMap[j];
                    var map  = window.AppInstance.instance().zone_color_map[processed_spot.length-1].ZoneMap[j];
                    var rgb  = ColorHelper.rgbArrayToHex( Cx.interpolate_rgb( Cx.Color.White().rgbArray(), ColorHelper.hex2rgb('#'+spot.RGB), tint ) ) ;
                    color_set_tuple.push({ 'Item1': color_zones[map].value.tag(), 'Item2': [rgb] });
                }
            }
        });
        all_tuples.push(color_set_tuple);
    });

    return all_tuples;
  };

  static get_spotcolor_tuples ( doc_figure ) {
    var all_tuples = [];
    var color_sets = JSON.parse(decodeURI(doc_figure.metadata.get('colorSet')));

    var original_spot = Cx.isArray(color_sets[0].Color) ? color_sets[0].Color : [color_sets[0].Color] ;

    for ( var i = 0 ; i < original_spot.length; i++)
    {
        if ( ( original_spot[i].ColorName == null ) || ( original_spot[i].ColorName.length == 0 ) )
            original_spot[i].ColorName = ColorHelper.hexaToNameFindAny(original_spot[i].RGB);
    }

    Cx_.forEach(color_sets, function(set) {
        var color_set_tuple = [];
        var set_color = Cx.isArray(set.Color) ? set.Color : [set.Color] ;
        //var target_rgb  = ColorHelper.rgbArrayToHex( Cx.interpolate_rgb( Cx.Color.White().rgbArray(), Cx.Color.fromRgb(set_val.RGB).rgbArray(), 1/color_zones[i].value.tint() ) ) ;
        Cx_.forEach(set_color, function(item, i) {
            if ( ( item.ColorName == null ) || ( item.ColorName.length == 0 ) )
                item.ColorName = ColorHelper.hexaToNameFindAny(item.RGB);
            color_set_tuple.push({ 'Item1': {'Item1': original_spot[i].ColorName, 'Item2': original_spot[i].RGB }
                                , 'Item2': {'Item1': item.ColorName, 'Item2': item.RGB } });
        });
        all_tuples.push(color_set_tuple);
    });

    return all_tuples;
  };

  static get_swatches_spotcolor_tuples(doc_figure) {
    var swatches = $('.choose-color-swatch .promo-masonry .promos') ;
    var color_sets = JSON.parse(decodeURI(window.AppInstance.instance().selected.metadata.get('colorSet')));
    var color_set_tuple = [];

    Cx_.forEach(swatches, function(swatch, i) {
        color_set_tuple.push({ 'Item1': {'Item1': $(swatch).find("input[name=origName]").val(), 'Item2': $(swatch).find("input[name=origHex]").val() }
                            , 'Item2': {'Item1': $(swatch).find("input[name=selectedName]").val(), 'Item2': $(swatch).find("input[name=selectedHex]").val() } });
        color_set_tuple;
    });

    return color_set_tuple;
  }

  static get_swatches_color_tuples(doc_figure) {
    var all_tuples = [];
    var swatches = $('.choose-color-swatch .promo-masonry .promos') ;
    var color_zones = Cx.uniqueColorZones(window.AppInstance.instance().doc_figures);
    var color_set_tuple = [];

    Cx_.forEach(swatches, function(swatch, i) {
        var processed_spot = [];
        var spot = $(swatch).find("input[name=origName]").val() ;
        var hex  = $(swatch).find("input[name=selectedHex]").val() ;
        for (var j = 0; j < window.AppInstance.instance().zone_color_map[i].ZoneMap.length; j++)
        {
            var tint = window.AppInstance.instance().zone_color_map[i].TintMap[j];
            var map  = window.AppInstance.instance().zone_color_map[i].ZoneMap[j];
            var rgb  = ColorHelper.rgbArrayToHex( Cx.interpolate_rgb( Cx.Color.White().rgbArray(), ColorHelper.hex2rgb('#'+hex), tint ) ) ;
            color_set_tuple.push({ 'Item1': color_zones[map].value.tag(), 'Item2': [rgb] });
        }
    });

    return color_set_tuple;
  }

  static target_colors_from_tuples(tuple) {
    var target_colors = [];
    Cx_.forEach(tuple, function (tuple_content) {
        target_colors.push(tuple_content.Item2);
    });
    return target_colors;
  }

  static tuples_to_swatch_array(tuples)
  {
    var sa = [];
    Cx_.forEach(tuples, function(t) {
      sa.push({ RGB: t.Item2.Item2, ColorName: t.Item2.Item1});
    });
    return sa;
  }
}